import Slider from "react-slick";
import React from "react";

function Feedbacknew() {
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div class="feedback-area  pb-100 mt-30">
      <div class="container">
        <div
          class="row justify-content-center align-items-center"
          data-cues="slideInUp"
        >
          <div class="col-lg-3 col-md-12">
            <div class="feedback-wrap-content">
              <span class="sub">Tales From The Real Estate</span>
              <h2>Our Clients Feedback.</h2>
            </div>
          </div>
          <div class="col-lg-9 col-md-12">
            <div class="swiper feedback-slider">
              <div class="swiper-wrapper">
                <Slider {...settings}>
                  <div class="swiper-slide">
                    <div class="feedback-card">
                      <ul class="rating">
                        <li>
                          <i class="ri-star-fill"></i>
                        </li>
                        <li>
                          <i class="ri-star-fill"></i>
                        </li>
                        <li>
                          <i class="ri-star-fill"></i>
                        </li>
                        <li>
                          <i class="ri-star-fill"></i>
                        </li>
                        <li class="gray">
                          <i class="ri-star-fill"></i>
                        </li>
                      </ul>
                      <p>
                        "I recently invested in a property with this company,
                        and I’m extremely satisfied. The development is
                        progressing rapidly, and the amenities like the park,
                        gym, temple, yoga center, and kids' play area are
                        impressive. The staff is always polite, professional,
                        and quick to respond. My family and I are thrilled with
                        our new home!
                        <br />
                        Thankyou GATWAY LANDMARK GROUP.”
                      </p>
                      <div class="info">
                        <h3>Surjal Sharma</h3>
                      </div>
                    </div>
                  </div>

                  <div class="swiper-slide">
                    <div class="feedback-card">
                      <ul class="rating">
                        <li>
                          <i class="ri-star-fill"></i>
                        </li>
                        <li>
                          <i class="ri-star-fill"></i>
                        </li>
                        <li>
                          <i class="ri-star-fill"></i>
                        </li>
                        <li>
                          <i class="ri-star-fill"></i>
                        </li>
                        <li>
                          <i class="ri-star-fill"></i>
                        </li>
                      </ul>
                      <p>
                        “My father took a plot of Nirwaan Vikas from Gatway
                        Landmark Group1 year ago and today its price has
                        increased by 10%. Thank you sir.”
                      </p>
                      <div class="info">
                        <h3>Ankit Kumar</h3>
                      </div>
                    </div>
                  </div>

                  <div class="swiper-slide">
                    <div class="feedback-card">
                      <ul class="rating">
                        <li>
                          <i class="ri-star-fill"></i>
                        </li>
                        <li>
                          <i class="ri-star-fill"></i>
                        </li>
                        <li>
                          <i class="ri-star-fill"></i>
                        </li>
                        <li>
                          <i class="ri-star-fill"></i>
                        </li>
                        <li class="gray">
                          <i class="ri-star-fill"></i>
                        </li>
                      </ul>
                      <p>
                        “"Thanks to Gatway Landmark GroupScheme One, I was able
                        to successfully sell my plot. The process was smooth,
                        and I appreciate their support throughout. Thank
                        you,GATWAY LANDMARK GROUP!"”
                      </p>
                      <div class="info">
                        <h3>Mr.Shankar RAM Kumawat </h3>
                      </div>
                    </div>
                  </div>
                  {/* <div class="swiper-slide">
                                <div class="feedback-card">
                                    <ul class="rating">
                                        <li><i class="ri-star-fill"></i></li>
                                        <li><i class="ri-star-fill"></i></li>
                                        <li><i class="ri-star-fill"></i></li>
                                        <li><i class="ri-star-fill"></i></li>
                                        <li><i class="ri-star-fill"></i></li>
                                    </ul>
                                    <p>  Gatway Landmark Groupis good & best property provider company in jaipur. I'm purchase a property recently all over experience is nice. Thank you GATWAY LANDMARK GROUP”</p>
                                    <div class="info">
                                        <h3>Mr. Anil Bairwa</h3>
                                      
                                    </div>
                                </div>
                            </div> */}
                </Slider>
              </div>
              <div class="feedback-pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Feedbacknew;
